module.exports = __webpack_public_path__ + "static/media/SlatePro-Bold.6afc5401.otf";